<template lang="pug">
  b-modal#createMatch(
  ref="createMatch"
  :title="$t('ui.combine.create_match')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$tc('ui.sports', 1)").mb-0
        b-input-group(size="sm")
          model-list-select(
            :list="sportList"
            option-value="sport_id"
            option-text="sport_type"
            ref="dataAdd_sportID"
            :class="{ 'is-invalid': $v.dataAdd_sportID.$dirty == true && $v.dataAdd_sportID.$error == true, 'is-valid': $v.dataAdd_sportID.$dirty == true && $v.dataAdd_sportID.$error == false }"
            v-model="$v.dataAdd_sportID.$model"
            :isDisabled="loading"
            @input="sportOnChange()"
            placeholder="Select your option")
          ValidateResult(:value="$v.dataAdd_sportID" :name="$t('ui.sport')")
      b-form-group(:label="$tc('ui.leagues', 1)" :disabled="dataAdd_sportID.sport_id == ''").mb-0
        b-input-group(size="sm")
          model-list-select(
            :list="leagueList"
            option-value="league_id"
            option-text="league_name"
            ref="dataAdd_leagueID"
            :class="{ 'is-invalid': $v.dataAdd_leagueID.$dirty == true && $v.dataAdd_leagueID.$error == true, 'is-valid': $v.dataAdd_leagueID.$dirty == true && $v.dataAdd_leagueID.$error == false }"
            v-model="$v.dataAdd_leagueID.$model"
            :isDisabled="loading"
            placeholder="Mapped league only")
        ValidateResult(:value="$v.dataAdd_leagueID" :name="$tc('ui.leagues', 1)")
      b-form-group(:label="$t('ui.home')" :disabled="$v.dataAdd_sportID.$model == 0").mb-0
        b-input-group(size="sm")
          model-list-select(
            :list="teamList"
            option-value="team_id"
            option-text="team_name"
            ref="dataAdd_homeID"
            :class="{ 'is-invalid': $v.dataAdd_homeID.$dirty == true && $v.dataAdd_homeID.$error == true, 'is-valid': $v.dataAdd_homeID.$dirty == true && $v.dataAdd_homeID.$error == false }"
            v-model="$v.dataAdd_homeID.$model"
            :isDisabled="loading"
            placeholder="Mapped team only")
        ValidateResult(:value="$v.dataAdd_homeID" :name="$t('ui.home')")
      b-form-group(:label="$t('ui.away')" :disabled="$v.dataAdd_sportID.$model == 0").mb-0
        b-input-group(size="sm")
          model-list-select(
            :list="teamList"
            option-value="team_id"
            option-text="team_name"
            ref="dataAdd_awayID"
            :class="{ 'is-invalid': $v.dataAdd_awayID.$dirty == true && $v.dataAdd_awayID.$error == true, 'is-valid': $v.dataAdd_awayID.$dirty == true && $v.dataAdd_awayID.$error == false }"
            v-model="$v.dataAdd_awayID.$model"
            :isDisabled="loading"
            placeholder="Mapped team only")
        ValidateResult(:value="$v.dataAdd_awayID" :name="$t('ui.away')")
      b-form-group(:label="$t('ui.market_type')").mb-0
        b-input-group(size="sm")
          model-list-select(
            :list="marketList"
            option-value="value"
            option-text="text"
            ref="dataAdd_marketType"
            :class="{ 'is-invalid': $v.dataAdd_marketType.$dirty == true && $v.dataAdd_marketType.$error == true, 'is-valid': $v.dataAdd_marketType.$dirty == true && $v.dataAdd_marketType.$error == false }"
            v-model="$v.dataAdd_marketType.$model"
            :isDisabled="loading"
            placeholder="Select your option")
        ValidateResult(:value="$v.dataAdd_marketType" :name="$t('ui.market_type')")
      div.row
        div.col-6
          b-form-group(:label="$t('ui.match_date')").mb-0
            b-input-group(size="sm")
              date-picker(v-model.trim.lazy="$v.dataAdd_matchDate.$model" :config="locale")
            ValidateResult(:value="$v.dataAdd_matchDate" :name="$t('ui.match_datetime')")
        div.col-6
          b-form-group(:label="$t('ui.match_time')").mb-0
            b-input-group(size="sm")
              vue-timepicker(v-model.trim.lazy="$v.dataAdd_matchTime.$model" format="hh:mm A" close-on-complete hide-clear-button)
            ValidateResult(:value="$v.dataAdd_matchTime" :name="$t('ui.match_time')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, url } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import SelectedSportDropDownList from "@/library/SportList";
import SelectedLeagueDropDownList from "@/library/LeagueList";
import SelectedTeamDropDownList from "@/library/TeamList";
import SelectedMarketDropDownList from "@/library/MarketList";
import VueTimepicker from 'vue2-timepicker';
import vueMultiSelect from 'vue-multi-select';
import { ModelListSelect } from 'vue-search-select';
const notEmptyOrSelected = (value) => (value != '' || value != 0);
const notEmptyArray = (x) => (x.sport_id != '' || x.league_id != '' || x.team_id != '' || x.value != '');

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    SelectedSportDropDownList,
    SelectedLeagueDropDownList,
    SelectedTeamDropDownList,
    SelectedMarketDropDownList,
    VueTimepicker,
    vueMultiSelect,
    ModelListSelect
  },
  data() {
    return {
      dataAdd_sportID: {
        sport_id: '',
        sport_type: ''
      },
      dataAdd_leagueID: {
        league_id: '',
        league_name: ''
      },
      dataAdd_homeID: {
        team_id: '',
        team_name: ''
      },
      dataAdd_awayID: {
        team_id: '',
        team_name: ''
      },
      dataAdd_marketType: {
        value: '',
        text: ''
      },
      dataAdd_matchDate: null,
      dataAdd_matchTime: {
        hh: '12',
        mm: '00',
        A: 'PM',
      },
      loading: false,
      feedback: {
        success: true,
        status: "",
        match_id: "",
        sbo_match_id: "",
        ibc_match_id: ""
      },
      sportList: [],
      leagueList: [],
      teamList: [],
      marketList: [
        { text: this.$t('ui.early'), value: "early"},
        { text: this.$t('ui.today'), value: "today"},
        { text: this.$t('ui.live'), value: "live"}
      ],
      locale: {
        format: "YYYY-MM-DD",
        useCurrent: true
      }
    };
  },
  computed: {
    todayDate() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    todayTime() {
      return this.$moment(new Date).format('hh:mm A');
    },
  },
  validations: {
    dataAdd_sportID: {
      required,
      notEmptyArray
    },
    dataAdd_leagueID: {
      required,
      notEmptyArray
    },
    dataAdd_homeID: {
      required,
      notEmptyArray
    },
    dataAdd_awayID: {
      required,
      notEmptyArray
    },
    dataAdd_marketType: {
      required,
      notEmptyArray
    },
    dataAdd_matchDate: {
      required
    },
    dataAdd_matchTime: {
      required
    }
  },
  mounted: function() {
    this.getSportList();
  },
  methods: {
    getSportList() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.linkedmatch
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list.filter(item => { return item.sport_id > 0; });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getLeagueLookup() {
      let url = config.leagueLookupUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.linkedmatch,
        sport_id: this.dataAdd_sportID.sport_id
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.leagueList = response.data.tbl_league_lookup;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTeamLookup() {
      let url = config.teamLookupUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.linkedmatch,
        sport_id: this.dataAdd_sportID.sport_id
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.teamList = response.data.tbl_team_lookup;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    sportOnChange() {
      this.getLeagueLookup();
      this.getTeamLookup();
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.createMatchUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.linkedmatch,
          sport_id: this.dataAdd_sportID.sport_id,
          league_id: this.dataAdd_leagueID.league_id,
          home_id: this.dataAdd_homeID.team_id,
          away_id: this.dataAdd_awayID.team_id,
          match_date: this.dataAdd_matchDate,
          match_time: this.dataAdd_matchTime['hh'] + ':' + this.dataAdd_matchTime['mm'] + this.dataAdd_matchTime['A'],
          market_type: this.dataAdd_marketType.value,
          provider: 'ALL'
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                this.feedback.match_id = response.data.match_id;
                this.feedback.sbo_match_id = response.data.sbo_match_id;
                this.feedback.ibc_match_id = response.data.ibc_match_id;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.createMatch.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "create_match", this.feedback.status);
                  this.$refs.createMatch.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.dataAdd_sportID = {
        sport_id: '',
        sport_type: ''
      };
      this.dataAdd_leagueID = {
        league_id: '',
        league_name: ''
      };
      this.dataAdd_homeID = {
        team_id: '',
        team_name: ''
      };
      this.dataAdd_awayID = {
        team_id: '',
        team_name: ''
      };
      this.dataAdd_marketType = {
        value: '',
        text: ''
      };
      this.dataAdd_matchDate = this.todayDate;
      this.dataAdd_matchTime = {
        hh: '12',
        mm: '00',
        A: 'AM',
      },
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataAdd_sportID.$el.focus();
    }
  }
};
</script>
<style lang="scss">
.select {
  height: 25.75px !important;
}

.select .buttonLabel {
  width: 450px !important;
  span:first-child {
    float: left !important;
    font-size: 0.65625rem !important;
    vertical-align: middle !important;
    margin-top: 4px !important;
  }
}

.select .caret {
  float: right !important;
  margin: 10px 4px 1px 12px !important;
}

.ui.selection.dropdown.is-invalid {
  border-color: #bd4575;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%232f353a' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px, url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23bd4575' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23bd4575' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  // background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2300ffff' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.ui.selection.dropdown.is-valid {
  border-color: #3b885f;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%232f353a' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px, url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%233b885f' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  // background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2300ffff' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.ui.selection.dropdown {
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%232f353a' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
}

.ui.selection.dropdown>.dropdown.icon {
  display: none !important;
}

.ui.dropdown, .ui.dropdown input {
  font-size: 10.5px !important;
}

.ui.dropdown .menu>.item {
  font-size: 10.5px !important;
}

.ui.selection.dropdown .menu>.item {
  padding: 6px 8px !important;
}

.ui.dropdown .menu .selected.item, .ui.dropdown.selected {
  background: lightblue !important;
}

</style>